import { createNumberMask } from 'text-mask-addons'

export const ONE_NUMBER_MASK = [/\d/]
export const TWO_NUMBER_MASK = [/\d/, /\d/]
export const THREE_NUMBER_MASK = [/\d/, /\d/, /\d/]
export const THREE_NUMBER_MASK_WITHOUT_ZERO_AT_FIRST = [/[1-9]/, /\d/, /\d/]
export const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
export const DATE_FOLHA_MASK = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
export const CPF_MASK = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
export const CEP_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
export const CNPJ_MASK = [
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '/',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '-',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/
]

export const CNPJ_ALFANUMERICO_MASK = [
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '.',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '.',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '/',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '-',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/
]

export const HOUR_MINUTE_MASK = [/\d/, /\d/, ':', /\d/, /\d/]

export const TELEFONE_MASK = inputValue => {
  const numbers = inputValue.match(/\d/g) || []
  const numberLength = numbers.join('').length

  if (numberLength > 10)
    return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

  return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
}

export const UF_MASK = [/[A-Za-z]/, /[A-Za-z]/]

export const PERCENT_MASK = createNumberMask({
  prefix: '',
  allowDecimal: true,
  integerLimit: 2,
  decimalSymbol: ','
})

export const COEFICIENTE_MASK = createNumberMask({
  prefix: '',
  allowDecimal: true,
  thousandsSeparatorSymbol: '.',
  decimalLimit: 6,
  decimalSymbol: ','
})

export const COEFICIENTE_MASK_4_INTEGERS = createNumberMask({
  prefix: '',
  allowDecimal: true,
  thousandsSeparatorSymbol: '.',
  integerLimit: 4,
  decimalLimit: 6,
  decimalSymbol: ','
})

export const COEFICIENTE_MASK_UNLIMITED = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowDecimal: true,
  decimalLimit: 99999,
  decimalSymbol: ','
})

export const PERCENTAGE_MASK_3_INTEGERS = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowDecimal: true,
  integerLimit: 3,
  decimalLimit: 2,
  decimalSymbol: ','
})

export const NUMBER_MASK = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowDecimal: false,
  integerLimit: 99999
})

export const cpfPartialMask = cpf => {
  if (cpf) {
    const reg = /\d/g
    const hiddenChar = cpf.slice(0, 3) + cpf.slice(3, 9).replace(reg, '*') + cpf.slice(9, 12)
    return hiddenChar
  }
  return
}

export const cpfCompleteMask = cpf => {
  if (cpf) {
    const reg = /\d/g
    const hiddenChar = cpf.slice(0, 12).replace(reg, '*')
    return hiddenChar
  }
  return
}

const CPF_IN_TEXT_REGEX = /\b(\d{3})\.?(\d{3})\.?(\d{3})-?(\d{2})\b/g

export const maskCpfInText = text => (text ? text.replace(CPF_IN_TEXT_REGEX, '$1.***.***-$4') : text)

export const getAnyCharMask = length => Array(length).fill(/./)
export const getAnyCharMaskWithoutSpace = length => Array(length).fill(/[^\s]/)

export const formatFileSize = bytes => {
  if (bytes < 1024) {
    return `${bytes} B`
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
